export default __webpack_public_path__ + "static/media/eon reality.8094dddc.png";